{
  "id": "campaign-157",
  "name": "Willow Brook",
  "seed": "campaign:157",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".......mm.............",
    "........m.......,,,...",
    ".k...............,....",
    ".......#..T...........",
    ".T.......k............",
    ".............m........",
    ".....wwwwww..mm.w+wwww",
    "...w+w....w+wwwww.....",
    "wwww..................",
    ".......#.x............",
    ".....................k",
    "....#.................",
    ".......x........#.....",
    "....m.*.............m.",
    ".....................m",
    "..x.......x..h........",
    "......................",
    "......Y...............",
    "..........x..h....Y...",
    "......................",
    "..........h.k.........",
    "......h.......T......S"
  ],
  "critters": [
    {
      "kind": "stag",
      "x": 18,
      "y": 4
    },
    {
      "kind": "fox",
      "x": 10,
      "y": 12
    },
    {
      "kind": "fox",
      "x": 8,
      "y": 0
    },
    {
      "kind": "deer",
      "x": 20,
      "y": 17
    },
    {
      "kind": "deer",
      "x": 20,
      "y": 16
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 14,
      "y": 16
    },
    {
      "kind": "gas",
      "x": 8,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 9,
      "y": 12
    },
    {
      "kind": "gas",
      "x": 5,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 20,
      "y": 19
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 21
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 20
    },
    {
      "kind": "repair",
      "x": 9,
      "y": 0
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 8,
      "y": 9,
      "w": 5,
      "h": 5
    },
    {
      "x": 1,
      "y": 9,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 157,
  "biome": "meadow",
  "par": {
    "reel": 16818,
    "push": 14688,
    "selfPropelled": 13086,
    "tractor": 11300,
    "zeroTurn": 9710,
    "fairway": 5817
  },
  "goldTime": {
    "reel": 16818,
    "push": 14688,
    "selfPropelled": 13086,
    "tractor": 11245,
    "zeroTurn": 9516,
    "fairway": 5817
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 17,
      "zeroTurn": 19,
      "fairway": 13
    },
    "gold": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 25,
      "zeroTurn": 33,
      "fairway": 13
    }
  }
}
